import { combineReducers, configureStore, UnknownAction } from '@reduxjs/toolkit';
import adminAuthReducer, { adminLogout } from './slices/adminAuthSlice';
import adminUsersReducer from './slices/adminUsersSlice';
import adminVerificationsReducer from './slices/adminVerificationsSlice';
import adminPlansReducer from './slices/adminPlansSlice';
import analyticsReducer from './slices/adminAnalyticsSlice';
import adminPaymentsReducer from './slices/adminPaymentsSlice';
import uiReducer from './slices/adminUiSlice';

const appReducer = combineReducers({
  adminAuth: adminAuthReducer,
  adminUsers: adminUsersReducer,
  adminVerifications: adminVerificationsReducer,
  adminPlans: adminPlansReducer,
  analytics: analyticsReducer,
  adminPayments: adminPaymentsReducer,
  ui: uiReducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: RootState | undefined, action: UnknownAction): RootState => {
  if (state && (adminLogout.fulfilled.match(action) || adminLogout.rejected.match(action))) {
    return appReducer({ ui: state.ui } as RootState, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({ reducer: rootReducer });

export type AppDispatch = typeof store.dispatch;
